export const builderResaleReducer = (state = { loading: false }, action) => {
  switch (action.type) {
    case "GET_BUILDER_RESALE_LIST_REQUEST":
      return { ...state, loading: true, builderResaleList: null, error: null };

    case "GET_BUILDER_RESALE_LIST_SUCCESS":
      return { ...state, loading: false, builderResaleList: action.payload, error: null };

    case "GET_BUILDER_RESALE_LIST_FAILED":
      return { ...state, loading: false, builderResaleList: null, error: action.payload };

    case "GET_BUILDER_RESALE_REQUEST":
      return { ...state, loading: true, builderResale: null, error: null };

    case "GET_BUILDER_RESALE_SUCCESS":
      return { ...state, loading: false, builderResale: action.payload, error: null };

    case "GET_BUILDER_RESALE_FAILED":
      return { ...state, loading: false, builderResale: null, error: action.payload };

    case "ADD_NEW_BUILDER_RESALE_REQUEST":
      return { ...state, loading: true, error: null };

    case "ADD_NEW_BUILDER_RESALE_SUCCESS":
      return {
        ...state,
        loading: false,
        lastAddedBuilderResale: action.payload.data,
        error: null,
      };

    case "ADD_NEW_BUILDER_RESALE_FAILED":
      return { ...state, loading: false, error: action.payload };

    case "UPDATE_BUILDER_RESALE_REQUEST":
      return { ...state, loading: true, error: null };

    case "UPDATE_BUILDER_RESALE_SUCCESS":
      return {
        ...state,
        loading: false,
        updatedBuilderResale: action.payload.data,
        error: null,
      };

    case "UPDATE_BUILDER_RESALE_FAILED":
      return { ...state, loading: false, error: action.payload };

    case "CHANGE_BUILDER_RESALE_STATUS_REQUEST":
      return { ...state, loading: true, error: null };

    case "CHANGE_BUILDER_RESALE_STATUS_SUCCESS":
      return {
        ...state,
        loading: false,
        builderResaleStatusUpdated: action.payload.data,
        error: null,
      };

    case "CHANGE_BUILDER_RESALE_STATUS_FAILED":
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};